import { search } from "../../../../../BaseRepositoryComponents";

const searchParams = new URLSearchParams(window.location.search);
const path = `${process.env.REACT_APP_URL_API_ERP_V3}/multitenant/log/financeiro/conciliacao`;

const headers = new Headers();
const token = `Bearer ${searchParams.get("gfAccessToken") || ""}`;
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findTitleLog({ extrato_transacao_id }) {
  const url = `${path}/bancaria?extrato_transacao_id=${extrato_transacao_id}`;

  return search(decodeURIComponent(url), "GET", headers);
}

export async function findFileLog({ arquivo_ofx_id }) {
  const url = `${path}/historico-ofx?arquivo_ofx_id=${arquivo_ofx_id}`;

  return search(decodeURIComponent(url), "GET", headers);
}
